import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderSassMobileMenu = () => openPopupHelper({ popupName: popupNames.SASS_MOBILE_MENU });
